<div provideParentForm>
    <avi-data-grid
        [config]="clientInfoGridConfig"
        [rows]="clientInfoList.config"
        [invalidateForm]="clientInfoList.isEmpty()"
    >
        <avi-data-grid_actions>
            <cds-button
                size="sm"
                (click)="addClientInfo()"
            >
                {{ l10nKeys.addButtonLabel | vtranslate }}
            </cds-button>
        </avi-data-grid_actions>
        <ng-template
            #clientInfoIpTemplateRef
            let-row
            let-index="index"
        >
            <avi-input-container noMarginTop>
                <input
                    type="text"
                    name="{{ 'clientInfo_' + index }}"
                    clrInput
                    placeholder="{{ l10nKeys.clientIpPlaceholder | vtranslate }}"
                    [(ngModel)]="row.config.client_ip"
                    [disabled]="row.config.client_cert"
                    regexPattern="ip"
                    required
                />
            </avi-input-container>
        </ng-template>
    </avi-data-grid>
</div>
